import { TextSmall } from '@/components/Texts';
import React from 'react';

const ContactDetailsDataProtection = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (3) Contact details of the data protection officer
      </TextSmall>
      <TextSmall>
        Our company data protection officer is available at all times to answer
        any questions you may have and to act as your contact person on the
        subject of data protection at our company. His contact details are:
      </TextSmall>
      <TextSmall whiteSpace={'pre-line'}>{`GOT PRIVACY?!
Tobias Kohl
Annemarie-Renger-Straße 35
53332 Bornheim`}</TextSmall>
    </>
  );
};

export default ContactDetailsDataProtection;
